
import { bl_fi_frame_file_hdr_RowClass } from "../../../dbschema";
import { BaseContainerModel } from "../../base-container.model";

export class FrameContainerModel extends BaseContainerModel {
  bl_fi_frame_file_hdr: bl_fi_frame_file_hdr_RowClass = new bl_fi_frame_file_hdr_RowClass();
}
